/* eslint-disable no-unused-vars */
export enum EWebmailConfigEndpoints {
 AUTODISCOVER = "/docker/maildomain/check-autodiscover",
 SRV = "/docker/maildomain/check-srv",
 SPF = "/docker/maildomain/check-spf",
 DKIM = "/docker/maildomain/check-dkim",
 DMARC = "/docker/maildomain/check-dmarc",
 CONFIG = "/docker/maildomain/check-config"
}
